// extracted by mini-css-extract-plugin
module.exports = {"root":"EffettoCard_root__z0mTy","imageBox":"EffettoCard_imageBox__lFP5C","title":"EffettoCard_title__RfEx8","rotation":"EffettoCard_rotation__hKt6c"};